import React from 'react'
import './large-view-event-edit.css'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { format, isValid, parseISO } from 'date-fns'
import { editSoloEvent } from '../../../../Calendar/calendarFunctions'
import { MuiPicker } from '../../../../MuiPicker'

const LargeViewEventEdit = ({event, setOpenEvent, setKeepEditing, setEditing, setChangeMultipleEvents, setEventObjectToEdit, somethingWasChanged, setSomethingWasChanged, setAllEvents, socket}) => {
    const [initialRecurringStatus, setInitialRecurringStatus] = React.useState(false)
    const [submittingEdit, setSubmittingEdit] = React.useState(false)

    React.useEffect(() => {
        setInitialRecurringStatus(event.recurring.isOn)
        setSubmittingEdit(false)
    }, [event])

    const changeLessonName = (value) => {
        setSomethingWasChanged(true)
        setOpenEvent(prev => ({...prev, name: value}))
    }

    const changeRepeatStatus = (value) => {
        setSomethingWasChanged(true)
        value === 'none' ? setOpenEvent((prev) => ({...prev, recurring:{isOn: false, frequency: value, interval: 0}})) : setOpenEvent((prev) => ({...prev, recurring:{isOn: true, frequency: value, interval: 0}}))
    }

    const changeLessonLength = (value) => {
        setSomethingWasChanged(true)
        setOpenEvent(prev => ({...prev, lessonLength: value}))
    }

    const tryToCloseEdit = async () => {
        if(submittingEdit) {
            return
        }

        if(isValid(new Date(event.dateTime))) {
            if(!somethingWasChanged) {
                setEditing(false)
            } else if (somethingWasChanged && event.recurring.isOn && initialRecurringStatus) {
                setSubmittingEdit(true)
                setChangeMultipleEvents(true)
            } else if (somethingWasChanged && !event.recurring.isOn && !initialRecurringStatus) {
                setSubmittingEdit(true)
                await editSoloEvent(event, setAllEvents, setEditing, socket, event.teacherName)
            } else if (somethingWasChanged && !event.recurring.isOn && initialRecurringStatus) {
                setSubmittingEdit(true)
                setChangeMultipleEvents(true)
            } else if (somethingWasChanged && event.recurring.isOn && !initialRecurringStatus) {
                setSubmittingEdit(true)
                await editSoloEvent(event, setAllEvents, setEditing, socket, event.teacherName)
            }
        }
    }

    return (
        <div className='teacher-calendar-event-editing-wrapper' id='teacher-calendar-event-editing-wrapper'>
            <div className='teacher-calendar-event-editing__top-bar'>
                <div onClick={() => setKeepEditing(true)} className='teacher-calendar-event-editing__top-bar__back-btn'>
                    <p>Cancel</p>
                </div>
                <div className='teacher-calendar-event-editing__top-bar__title'>Edit Event</div>
                <div className='teacher-calendar-event-editing__top-bar__edit' style={isValid(new Date(event.dateTime)) ? {color: 'red', opacity: submittingEdit ? 0.55 : 1, pointerEvents: submittingEdit ? 'none' : 'auto'} : {color: 'grey'}} onClick={() => tryToCloseEdit()}>{submittingEdit ? 'Saving...' : 'Done'}</div>
            </div>
            <input className='teacher-calendar-event-editing__input' value={event.name} onChange={(e) => changeLessonName(e.target.value)} />
            <div className='teacher-calendar-event-editing__input-with-label__wrapper'>
                <div className='teacher-calendar-event-editing__input-label'>Starts</div>
                <div className='teacher-calendar-event-editing__date-time-picker__wrapper'>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <MuiPicker setNewEvent={setOpenEvent} newEvent={event} setSomethingWasChanged={setSomethingWasChanged}  />
                    </LocalizationProvider>
                </div>
            </div>
            {!isValid(new Date(event.dateTime)) && <div className='teacher-calendar-event-editing__date-time-warning'>Date/Time is not valid! (mm/dd/yyyy hh:mm:pm)</div>}
            <div className='teacher-calendar-event-editing__input-with-label__wrapper'>
                <div className='teacher-calendar-event-editing__input-label'>Length</div>
                <select className='teacher-calendar-event-editing__lesson-length-selector' value={event.lessonLength} onChange={(e) => changeLessonLength(e.target.value)}>
                    <option value={15}>15 min</option>
                    <option value={30}>30 min</option>
                    <option value={45}>45 min</option>
                    <option value={60}>60 min</option>
                </select>
            </div>
            {event.dateTime !== null && isValid(new Date(event.dateTime)) && 
              <div className='teacher-calendar-event-editing__input-with-label__wrapper'>
                <div className='teacher-calendar-event-editing__input-label'>Repeats:</div>
                <select value={event.recurring.frequency} className='teacher-calendar-event-editing__lesson-length-selector' onChange={(e) => changeRepeatStatus(e.target.value)}>
                  <option value="none">Does not Repeat</option>
                  <option value="weekly">Weekly on {new Date(event.dateTime) && format(new Date(event.dateTime), 'EEEE')}</option>
                  <option value="every-other-week">Every Other {new Date(event.dateTime) && format(new Date(event.dateTime), 'EEEE')}</option>
                </select>
              </div>
            }
        </div>
    )
}
export default LargeViewEventEdit
